<!--
 * @Author: Gaho
 * @Date: 2024-03-14 15:55:30
 * @LastEditors: Gaho
 * @LastEditTime: 2025-01-23 13:47:38
 * @Description: 
-->
<template>
    <div class="plinko-jackpot">
        <p class="modal-icon" @click="() => $emit('handleModal')">
            <IconSvgUse use="icon-question" size="15px" fill="#55657e" />
        </p>
        <!-- 左上角区域-弹框 start -->
        <ModalJackpot
            :visible="modalVisible"
            game="Plinko"
            :update="() => $emit('handleModal')"
        />
        <!-- 左上角区域-弹框 end -->
        <div class="jackpot-tooltip">
            <img src="@/assets/imgs/casino/jackpot.webp" alt="" />
            <div class="jackpot-btc">
                <p>{{ handleExchangeRate(jackpotSize).toFixed(0) }}</p>
                <p class="btc-text">{{ currentCurrency.toLocaleUpperCase() }}</p>
            </div>
        </div>
        <div class="jackpot-name">
            <span 
                v-for="(val, ind) in 'PLINKO'" 
                :key="val"
                :class="jackpot[ind] === 1 ? 'active' : ''"
            >
                {{ val }}
            </span>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import useSettingsStore from '@/stores/settings';
export default defineComponent({
    name: 'plinkoJackpot',
    props: {
        modalVisible: {
            type: Boolean,
            default: false
        },
        jackpotSize: {
            type: Number,
            default: 0
        },
        jackpot: {
            type: Array<Number>,
            default: []
        }
    },
    emits: ['handleModal'],
    computed: {
        currentCurrency(){
            return useSettingsStore().pickedCurrency || 'btc';
        }
    },
});
</script>
<style lang="scss" scoped>
// 左上角Jackpot
.plinko-jackpot {
    position: absolute;
    top: 4%;
    left: 9.5%;
    height: max-content;
    width: 132px;
    z-index: 1;

    .modal-icon {
        cursor: pointer;
        color: #55657e;
        position: absolute;
        right: -2px;

        &:hover {
            color: #fff;
        }
    }

    @media (max-width: 460px) {
        .modal-icon {
            right: -20px;
        }
    }

    .jackpot-tooltip {
        display: flex;
        flex-direction: column;
        padding: 0 0 0 4px;

        img {
            height: auto;
            margin-bottom: 4px;
            max-width: 110px;
            vertical-align: top;
            width: 100%;
        }

        .jackpot-btc {
            display: flex;
            font-size: 14px;
            font-weight: 800;
            line-height: 14px;
            white-space: nowrap;

            .btc-text {
                font-size: 15px;
                margin-left: 5px;
            }
        }

        @media (max-width: 440px) {
            .jackpot-btc {
                font-size: 12px;

                .btc-text {
                    font-size: inherit;
                }
            }
        }

        @media (max-width: 390px) {
            .jackpot-btc {
                font-size: 11px;
            }
        }
    }

    @media (max-width: 460px) {
        .jackpot-tooltip {
            justify-content: space-between;
            padding: 0 4px 0 0;
            width: 43%;

            img {
                margin-bottom: 0;
            }
        }
    }

    .jackpot-name {
        display: flex;
        justify-content: space-between;
        margin-top: 4px;

        span {
            align-items: center;
            background: #0f1125;
            border: 1px solid #1a202d;
            border-radius: 5.27177px;
            display: flex;
            font-size: 9px;
            font-weight: 600;
            height: 17px;
            justify-content: center;
            letter-spacing: -0.02em;
            line-height: 10px;
            opacity: 0.9;
            text-transform: uppercase;
            width: 20px;
        }
        .active {
            background: #ffb636;
            border: .6px solid #f09000;
            color: #6d4200;
        }
    }

    @media (max-width: 460px) {
        .jackpot-name {
            margin-top: 0;
            width: 57%;

            span {
                height: 100%;
                width: 16%;
            }
        }
    }
}

@media (max-width: 460px) {
    .plinko-jackpot {
        display: flex;
        left: 8.5%;
        top: 1.5%;
        width: 77.5%;
    }
}

@media (max-width: 390px) {
    .plinko-jackpot {
        top: 1.5%;
    }
}
</style>